import getInitialTaskQuota from "./getInitialTaskQuota";

const tasksState = {
    task: {
        account: {},
        name: null,
        active: true,
        public: false,
        show_question_ids: false,
        allow_back_btn: false,
        show_progress_bar: false,
        banner_img: null,
        instructions: '',
        thank_you: '',
        screen_out: '',
        closed_message: '',
        created_at: null,
        start_at: null,
        end_at: null,
        language: 'en',
        transcription_language: 'en_uk',
        project: {},
        reminders_enabled: true,
        incentive: {
            enabled: false,
            amount: 0
        },
        incentives_enabled: false,
        hide_others_answers_until_first: false,
        private_participant_session: false,
        automatic_transcriptions: true,
        counts: {
            subtasks: 0,
            participants: 0,
            invited: 0,
            accepted: 0,
            completed: 0,
            questions: 0,
            last_accepted: {
                accepted_at: null,
                user: null
            },
            last_completed: {
                completed_at: null,
                user: null
            }
        },
        message_type_count: [],
        roles: [],
        slug: '',
        uuid: '',
        demo: false,
        type: {
            name: null,
            value: null,
            slug: null,
            enable_quotas: null
        },
        qr: {
            prefilled_message: null
        },
        screener: false,
        url_data_params: [],
        quota: getInitialTaskQuota()
    },
    reminders: {
        data: [],
        meta: {},
        links: {}
    },
    groups: [],
    currentGroup: {},
    questionIds: [],
    quotaProfileGroups: null,
    userInfo: {
        uuid: null,
        waiting_list: null
    }
};

export default tasksState;
